import styled from "styled-components";

export const UserStatusWithdrawalLimitsStyled = styled.div`
    display: flex;
    flex-direction: column;
    gap: 24px;
`;

export const UserStatusWithdrawalLimitsStatusContainerStyled = styled.div`
    display: flex;
    gap: 16px;
`;

interface IUserStatusCircleProgressStyledProps {
    isUnlimited: boolean;
}

export const UserStatusWithdrawalLimitsStatusInfoStyled = styled.div<IUserStatusCircleProgressStyledProps>`
    display: flex;
    flex-direction: column;
    justify-content: ${({isUnlimited}) => isUnlimited ? 'center' : 'flex-start'};
    
    .amount {
        font-size: 16px;
    }
    
    .unlimited-amount {
        font-size: 20px;
    }
`;

export const UserStatusWithdrawalLimitsHistoryStyled = styled.div`
`;


export const UserStatusWithdrawalLimitsHistoryHeaderStyled = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 32px;
`;
